(function() {
  'use strict';

  function init() {
    // Botões de WhatsApp nas páginas de produto ("Orçar" e "Comprar pelo WhatsApp").
    // Abre o WhatsApp direto, sem formulário.
    document.querySelectorAll('[data-bmwa-product-trigger]').forEach(btn => {
      btn.addEventListener('click', () => {
        const number = (btn.dataset.waNumber || '').replace(/\D/g, '');
        const message = btn.dataset.waMessage || '';
        if (!number) return;

        // GTM — registra a intenção de contato
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'whatsapp_click',
          lead_product: btn.dataset.waProductHandle || '',
          page_url: window.location.href
        });

        window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`, '_blank');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();